// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Zdga","tab":"Tabs_tab__wZHEI","tabActive":"Tabs_tabActive__ZBJ9A"};